import { START_FETCH_RELATED_PRODUCTS, FINISH_FETCH_RELATED_PRODUCTS, type RelatedProductsActions } from "./actions";

import { type Reducer } from "redux";
import type { DictionaryLoadable } from "~/redux/loadableStore/types";
import { produce } from "immer";

export type RelatedProductsState = DictionaryLoadable<string[]>;

const initialState: RelatedProductsState = {};

export const relatedProductsReducer: Reducer<RelatedProductsState, RelatedProductsActions> = (
  state = initialState,
  action,
): RelatedProductsState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case START_FETCH_RELATED_PRODUCTS: {
        const { productCode } = action.payload;
        draft[productCode] = { state: "loading" };
        break;
      }
      case FINISH_FETCH_RELATED_PRODUCTS: {
        const { productCode, relatedProducts, error } = action.payload;
        draft[productCode] = {
          state: error ? "error" : "loaded",
          data: relatedProducts.map((product) => product.code),
        };
        break;
      }
    }
  });
};
